import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from './breadcrumb.component';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		NgbTooltipModule,
		TranslateModule.forChild()
	],
	declarations: [BreadcrumbComponent],
	exports: [BreadcrumbComponent]
})
export class BreadcrumbModule { }
